import { Label } from '@/components/base/label'
import type { SwitchProps } from '@/components/base/switch'
import { Switch } from '@/components/base/switch'
import { DEBOUNCE_MEDIA_CONSTRAINTS_MS } from '@/helpers/constants'
import { useOptimisticUpdateWithPromise } from '@/hooks/useOptimisticUpdateWithPromise'
import { useRoomStoreActions } from '@/stores/room'
import { useCallback, useId } from 'react'

type SwitchAutoGainControlProps = Omit<
  SwitchProps,
  'checked' | 'id' | 'onCheckedChange'
> & {
  autoGain: boolean
  memberId: string
}

export const SwitchAutoGainControl = ({
  autoGain,
  memberId,
  ...props
}: SwitchAutoGainControlProps) => {
  const { partialUpdateMicrophone } = useRoomStoreActions()

  const autoGainControlId = useId()

  const handleUpdateCallback = useCallback(
    (value: boolean) => {
      return partialUpdateMicrophone({
        constraints: { autoGain: value },
        memberId,
      })
    },
    [memberId, partialUpdateMicrophone],
  )

  const { optimisticValue, handleUpdate } = useOptimisticUpdateWithPromise(
    autoGain,
    handleUpdateCallback,
    DEBOUNCE_MEDIA_CONSTRAINTS_MS,
  )

  return (
    <>
      <Label htmlFor={autoGainControlId}>Auto Gain Control</Label>
      <Switch
        id={autoGainControlId}
        checked={optimisticValue}
        onCheckedChange={handleUpdate}
        {...props}
      />
    </>
  )
}
